import React from "react";
import "../pages/ClinicalServices/styles/therapy.css";

const ServiceWarning = () => {
  return (
    <section className="home-section fade-in">
      <div
        className="text-content"
        style={{
          width: "80%",
          padding: "2rem",
        }}
      >
        <h3>
          All services are offered exclusively virtually, giving you the freedom
          to prioritize your mental health from the comfort and privacy of your
          own space. Access care that fits into your life—no commute, no waiting
          rooms, just meaningful support wherever you feel most at ease.
        </h3>
      </div>
    </section>
  );
};

export default ServiceWarning;
